import {
  ResidentialApartmentPropertyDetails,
  ResidentialHousePropertyDetails,
} from '@unreserved-frontend-v2/api/generated/graphql/types'
import { DetailsTableRow } from '@unreserved-frontend-v2/ui/details-table/models'
import useTranslation from 'next-translate/useTranslation'
import { useMemo } from 'react'
import { faSquareParking } from '@fortawesome/pro-light-svg-icons'
import { emptyDefault } from '@unreserved-frontend-v2/utils/empty-default'

export const useParkingRow = (
  details?: ResidentialApartmentPropertyDetails | ResidentialHousePropertyDetails | null
): DetailsTableRow | undefined => {
  const { t } = useTranslation()

  return useMemo(() => {
    if (!details?.parkingRaw && details?.totalParkingSpots == null) {
      return
    }

    const count = details?.totalParkingSpots

    return {
      icon: faSquareParking,
      title: t('listings:details-pages.parking'),
      cells: [
        {
          id: 'parking-types',
          data: [
            {
              id: 'data-parking-types',
              label: count ? t('listings:details-pages.parking-spaces', { count }) : '',
              labelClassName: 'font-bold',
              value: emptyDefault(details?.parkingRaw),
              valueClassName: 'font-normal',
            },
          ],
        },
      ],
    }
  }, [details, t])
}
